const columns = [
  {
    field: 'code',
    label: 'Rodzaj dokumentu',
    sort: 'asc',
    type: "enum",
    enumType: "enums/legalDocumentCode",
    width: 150,
    parent: "legalDocument"
  },
  {
    field: 'title',
    label: 'Nazwa wersji',
    sort: 'asc',
    width: 150,
    parent: "legalDocument"
  },
  {
    field: 'version',
    label: 'Wersja',
    sort: 'asc',
    width: 150,
    parent: "legalDocument"
  },
  {
    field: 'creationDate',
    label: 'Data utworzenia',
    sort: 'asc',
    width: 150,
    parent: "legalDocument"
  },

  {
    field: 'file',
    label: 'Plik',
    sort: 'asc',
    width: 150,
    type: "file",
    parent: "legalDocument"

  },
  {
    field: 'acceptedAt',
    label: 'Data zatwierdzenia',
    sort: 'asc',
    width: 150,
  },
];

export default columns;
